import TitleHeader from "@standard/components/TitleHeader";
import JobForm from "./JobForm";
import JobTable from "./JobTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Transaction";
const programName = "Job";
const url = "transaction/job";

export default function ({ history }) {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <JobTable url={url} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <JobForm history={history} url={url} />
        </Route>
      </Switch>
    </>
  );
}
